// TEMPORARY (PROD_COMPANY_FILTER): on the production build only a fixed set
// of companies may be shown in the Dashboard / Report Register company
// filter and in the report data. To remove: delete this file and every
// PROD_COMPANY_FILTER usage (api/finvise_reports_api.js and
// pages/FinviseDashboard.jsx, pages/FinviseProperties.jsx).

import org_api from '../api/admin/admin_orgs'

export const IS_PROD = window.location.hostname === 'app.finvise.com'

const ALLOWED_COMPANIES = [
	'Hope Capital Specialist Lending / Hope Capital 2 Limited / Hope Capital 3 Limited / Hope Capital 4 Limited',
	'Gatehouse Bank',
	'Selina Finance Limited',
	'Bluecroft Finance Limited',
	'SM1 Capital & Security Limited, trading as Somo',
	'Breeze Capital Limited',
]

const normalise = name =>
	String(name || '')
		.replace(/\s+/g, ' ')
		.trim()
		.toLowerCase()

// a combined entry ("A / B / C") may be stored as one organisation or as
// several, so every slash-separated part is allowed on its own as well
const ALLOWED = new Set(
	ALLOWED_COMPANIES.flatMap(name => [name, ...name.split('/')]).map(normalise),
)

export const filterProdOrganisations = organisations =>
	IS_PROD
		? (organisations || []).filter(o => ALLOWED.has(normalise(o && o.name)))
		: organisations

// report rows from any other company are dropped right after the response
export const filterProdRows = rows =>
	IS_PROD ? rows.filter(r => ALLOWED.has(normalise(r.organization))) : rows

let allowedIdsPromise = null
const getAllowedOrgIds = () => {
	if (!allowedIdsPromise) {
		allowedIdsPromise = org_api
			.getOrganisations()
			.then(r =>
				filterProdOrganisations((r.data && r.data.organisations) || []).map(
					o => o.id,
				),
			)
			.catch(() => {
				allowedIdsPromise = null
				return []
			})
	}
	return allowedIdsPromise
}

// Main admin only (everyone else is already scoped to their own company by
// the server). Returns the company ids a request may cover, or null when no
// restriction applies. An empty array means nothing may be requested.
export const restrictProdOrgIds = async (isAdmin, orgId, orgIds) => {
	if (!IS_PROD || !isAdmin) return null
	const allowed = (await getAllowedOrgIds()).map(String)
	const wanted = orgIds && orgIds.length ? orgIds : orgId ? [orgId] : null
	if (!wanted) return allowed
	return wanted.filter(id => allowed.includes(String(id)))
}
